import React, { Component } from "react";
import styles from "./reportContructor.module.scss";
import { withReportsList } from "../../../shared/containers/containerReportsList";
import Scrollbars from "react-custom-scrollbars-2";
import { withCustomReport } from "../../../shared/containers/containerCustomReport";
import ModalConfirmWindow from "../../Contents/ModalComponents/ModalConfirmWindow";
import DeleteConfirm from "../../Contents/ModalComponents/DeleteConfirm";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { states } from "../../../reducers/queriesStates";

class ReportConstructorCustomList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isPatternListOpen: true,
      isModalConfirmOpen: false,
      selectedReport: null,
    };
  }

  componentDidUpdate(prevProps) {
    const { deleteCustomReportDataState } = this.props;

    if (prevProps.deleteCustomReportDataState === states.REQUEST && deleteCustomReportDataState === states.READY) {
      this.setState({ isModalConfirmOpen: false, selectedReport: null });
    }
  }

  onSelected(report) {
    const { onSelectedCustomReport } = this.props;

    onSelectedCustomReport(report.id)
    this.setState({ isModalConfirmOpen: false, selectedReport: report });
  }

  onModalConfirmOpen(selectedReport) {
    this.setState({ isModalConfirmOpen: true, selectedReport });
  }

  onDeleteHandler() {
    const { selectedReport } = this.state;
    const { onDeleteCustomReport } = this.props;

    onDeleteCustomReport({ id: selectedReport.id });
  }

  render() {
    const { reportsListData } = this.props;
    const { selectedReport, isModalConfirmOpen } = this.state;

    return (
      <div className={styles.controlReportPatternListContainer}>
        <Scrollbars style={{ height: "450px" }} autoHide={true} ref="scrollbar">
          {reportsListData
            .filter((report) => {
              return report.patternReport === undefined || report.patternReport === null;
            })
            .map((report) => {
              return (
                <div
                  className={styles.routeReportPatternListItem}
                  key={report.id}
                  onClick={() => {
                    this.onSelected(report);
                  }}
                >
                  {report.title}

                  <TooltipWrapper title={`Удалить ${report.title}`} position="right">
                    <div
                      className={styles.deleteButton}
                      onClick={(e) => {
                        e.stopPropagation();
                        this.onModalConfirmOpen(report);
                      }}
                    >
                      <DeleteOutlineIcon fontSize="small" />
                    </div>
                  </TooltipWrapper>
                </div>
              );
            })}
        </Scrollbars>
        {selectedReport != null ? (
          <ModalConfirmWindow isOpen={isModalConfirmOpen}>
            <DeleteConfirm
              onConfirmHandle={this.onDeleteHandler.bind(this)}
              onNotConfirmHandle={(e) => {
                this.setState({ isModalConfirmOpen: false });
              }}
              text={`Удалить ${selectedReport.title}?`}
            />
          </ModalConfirmWindow>
        ) : null}
      </div>
    );
  }
}

export default withCustomReport(withReportsList(React.memo(ReportConstructorCustomList)));
